import { useRecoilState } from "recoil";
import { phanHe } from "@/states/authen";
import { CONSTANTS } from "@/utils/constants";
import { useRouter } from "next/router";
import { resolvePhanHeFromRoute } from "@/utils/phanHeStorage";
 
export const useGetPhanHe = () => {
    const phanHeValue = useRecoilState(phanHe)[0];
    const router = useRouter();
    return resolvePhanHeFromRoute(router.pathname, router.asPath) ?? phanHeValue ?? CONSTANTS.PHAN_HE.BSC;
}
